import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sidebar", "submitButton", "dropdown", "sidebarTitle", "sidebarContent"];

  declare sidebarTarget : HTMLDivElement;
  declare submitButtonTarget: HTMLButtonElement;
  declare dropdownTarget: HTMLDivElement;
  declare hasDropdownTarget: boolean;
  declare sidebarTitleTarget: HTMLElement;
  declare sidebarContentTargets: HTMLDivElement[];

  toggleDropdown(event: Event) : void {
    event.stopPropagation();

    this.dropdownTarget.classList.toggle("is-active");
  }

  dismissDropdown() : void {
    if (this.hasDropdownTarget === true) {
      this.dropdownTarget.classList.remove("is-active");
    }
  }

  openSidebar({ params } : { params: { id: number } }) : void {
    this.sidebarTarget.classList.remove("is-collapsed");
    this.sidebarContentTargets.forEach(tg => tg.classList.add("is-hidden"));

    const sidebar = document.getElementById(params.id.toString());
    sidebar?.classList.remove("is-hidden");
    const autofocusElement = (sidebar?.querySelector("[autofocus]") as HTMLElement);
    autofocusElement?.focus();
  }

  closeSidebar(event: Event) : void {
    event.preventDefault();

    this.sidebarTarget.classList.add("is-collapsed");
    this.sidebarContentTargets.forEach(tg => tg.classList.add("is-hidden"));
  }

  disable(event: Event) : void {
    const submitter = (event as SubmitEvent).submitter as HTMLButtonElement;
    if (submitter) submitter.disabled = true;
  }

  enable(event: Event) : void {
    const submitter = (event as SubmitEvent).submitter as HTMLButtonElement;
    if (submitter) submitter.disabled = false;
  }

  showFilters() : void {
    this.sidebarTarget.classList.remove("is-collapsed-touch");
  }
}
